var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSolidEmpty = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none",
  viewBox: "0 0 40 40",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--solid-file-color, currentColor)",
  d: "M4 4a4 4 0 0 1 4-4h16l12 12v24a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--fg-white, currentColor)",
  d: "m24 0 12 12h-8a4 4 0 0 1-4-4z",
  opacity: 0.3
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSolidEmpty);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/solid-empty.fd50f64d93340492980c5b9854f87ccd.svg";